import cn from 'classnames'
import React, { ComponentProps } from 'react'

type ClockIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ClockIcon(props: ClockIconProps) {
  const { className = '', ...rest } = props

  return (
    <svg
      className={cn('ClockIcon', className)}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
    >
      <path
        d="M10.0013 18.3332C14.6037 18.3332 18.3346 14.6022 18.3346 9.99984C18.3346 5.39746 14.6037 1.6665 10.0013 1.6665C5.39893 1.6665 1.66797 5.39746 1.66797 9.99984C1.66797 14.6022 5.39893 18.3332 10.0013 18.3332Z"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 5V10L13.3333 11.6667"
        stroke={props.stroke || 'currentColor'}
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
